import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { BaseAPI } from '@app/core/class/baseAPI.class';
var CustomSubjectMailService = /** @class */ (function (_super) {
    tslib_1.__extends(CustomSubjectMailService, _super);
    function CustomSubjectMailService(httpClient) {
        var _this = _super.call(this, httpClient) || this;
        _this.httpClient = httpClient;
        _this.endpoint = '/custom-subject-notification';
        _this.apiFieldsMap = {};
        _this.fieldsRequired = ['subject', 'event'];
        return _this;
    }
    return CustomSubjectMailService;
}(BaseAPI));
export { CustomSubjectMailService };
